export const cx = (...classes: (string | undefined | false | null)[]): string =>
    classes.filter(Boolean).join(' ');

export const getResponsiveClamp = (
    min: number,
    max: number,
    viewMinWidth: number,
    viewMaxVidth: number,
): string =>
    `clamp(${min}px, calc(${min}px + (${max} - ${min}) * ` +
    `((100vw - ${viewMinWidth}px) / (${viewMaxVidth} - ${viewMinWidth}))), ` +
    `${max}px)`;
